(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["age-verifier"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', function () {
    window.Alpine.data('ageVerifier', function () {
      var STORAGE_KEY = 'nukes_age_verified';
      var THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

      return {
        visible: false,
        _focusableEls: [],

        init: function () {
          var stored = localStorage.getItem(STORAGE_KEY);
          if (stored) {
            var ts = parseInt(stored, 10);
            if (Date.now() - ts < THIRTY_DAYS_MS) {
              this.visible = false;
              return;
            }
          }

          this.visible = true;
          document.body.style.overflow = 'hidden';

          var self = this;
          this.$nextTick(function () {
            if (self.$refs.confirmBtn) {
              self.$refs.confirmBtn.focus();
            }
            self._cacheFocusable();
          });
        },

        confirm: function () {
          localStorage.setItem(STORAGE_KEY, Date.now().toString());
          this.visible = false;
          document.body.style.overflow = '';
        },

        deny: function (e) {
          e.preventDefault();
          var href = e.currentTarget.getAttribute('href') || 'https://www.google.com';
          window.location.href = href;
        },

        trapFocus: function (e) {
          this._cacheFocusable();
          var els = this._focusableEls;
          if (els.length === 0) return;

          var first = els[0];
          var last = els[els.length - 1];

          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        },

        _cacheFocusable: function () {
          if (!this.$refs.dialog) return;
          this._focusableEls = Array.from(
            this.$refs.dialog.querySelectorAll(
              'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            )
          );
        },

        destroy: function () {
          document.body.style.overflow = '';
        }
      };
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-upsell"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', function() {
    window.Alpine.data('cartUpsellAdd', function(config) {
      return {
        variantId: config.variantId,
        loading: false,
        added: false,

        addToCart: function() {
          var self = this;
          if (self.loading || self.added) return;
          self.loading = true;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: self.variantId, quantity: 1 }] })
          })
          .then(function(response) {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(function() {
            self.loading = false;
            self.added = true;
            document.dispatchEvent(new CustomEvent('cart:updated'));
            setTimeout(function() { self.added = false; }, 2000);
          })
          .catch(function() {
            self.loading = false;
          });
        }
      };
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["locale-selector"] && !Shopify.designMode) return;
  try {
    function submitLocalizationForm(form) {
    var body = new FormData(form);
    fetch(form.action, { method: 'POST', body: body })
      .then(function(response) {
        window.location.href = response.url;
      })
      .catch(function() {
        form.submit();
      });
  }

  document.addEventListener('click', function(e) {
    var langBtn = e.target.closest('[data-locale-code]');
    if (langBtn) {
      e.preventDefault();
      var form = langBtn.closest('form');
      if (form) {
        var input = form.querySelector('[name="locale_code"]');
        if (input) {
          input.value = langBtn.getAttribute('data-locale-code');
          submitLocalizationForm(form);
        }
      }
      return;
    }
    var countryBtn = e.target.closest('[data-country-code]');
    if (countryBtn) {
      e.preventDefault();
      var form = countryBtn.closest('form');
      if (form) {
        var input = form.querySelector('[name="country_code"]');
        if (input) {
          input.value = countryBtn.getAttribute('data-country-code');
          submitLocalizationForm(form);
        }
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-v2-ui"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.__pc2Init) return;
    window.__pc2Init = true;

    // Single delegated click handler for share + touch image toggle
    document.addEventListener('click', function(e) {
      // 1. Share button handler
      var btn = e.target.closest('[data-share-url]');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        var url = btn.getAttribute('data-share-url');
        var title = btn.getAttribute('data-share-title') || '';
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function() {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function() {
            var orig = btn.getAttribute('aria-label');
            btn.setAttribute('aria-label', 'Link copied!');
            // Clear any existing timer to prevent accumulation
            clearTimeout(btn._resetTimer);
            btn._resetTimer = setTimeout(function() { btn.setAttribute('aria-label', orig); }, 2000);
          }).catch(function() {});
        }
        return;
      }

      // 2. Touch image toggle (only on touch devices)
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      if (e.target.closest('a, button, input, select')) return;
      var media = e.target.closest('.pc2--has-alt-img .pc2__media');
      if (!media) return;
      var card = media.closest('.pc2--has-alt-img');
      if (card) card.classList.toggle('pc2--touch-active');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["promo-popup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', function () {
    window.Alpine.data('promoPopup', function () {
      return {
        open: false,
        _timer: null,

        init: function () {
          var self = this;
          var delay = parseInt(self.$root.dataset.promoDelay || '5', 10);
          var frequency = self.$root.dataset.promoFrequency || 'once';

          self._frequency = frequency;

          if (self._shouldShow()) {
            self._timer = setTimeout(function () {
              self.open = true;
            }, delay * 1000);
          }
        },

        destroy: function () {
          if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
          }
        },

        close: function () {
          this.open = false;
          this._markDismissed();
        },

        _shouldShow: function () {
          if (this._frequency === 'always') return true;

          if (this._frequency === 'session') {
            return !sessionStorage.getItem('nukes_promo_dismissed');
          }

          return !localStorage.getItem('nukes_promo_dismissed');
        },

        _markDismissed: function () {
          if (this._frequency === 'always') return;

          if (this._frequency === 'session') {
            sessionStorage.setItem('nukes_promo_dismissed', '1');
            return;
          }

          localStorage.setItem('nukes_promo_dismissed', '1');
        }
      };
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-chart"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', function () {
    window.Alpine.data('sizeChart', function () {
      return {
        isOpen: false,
        _previousFocus: null,
        _focusableEls: [],

        open: function () {
          this._previousFocus = document.activeElement;
          this.isOpen = true;
          document.body.style.overflow = 'hidden';

          var self = this;
          this.$nextTick(function () {
            if (self.$refs.closeBtn) {
              self.$refs.closeBtn.focus();
            }
            self._cacheFocusable();
          });
        },

        close: function () {
          this.isOpen = false;
          document.body.style.overflow = '';

          if (this._previousFocus) {
            this._previousFocus.focus();
            this._previousFocus = null;
          }
        },

        trapFocus: function (e) {
          this._cacheFocusable();
          var els = this._focusableEls;
          if (els.length === 0) return;

          var first = els[0];
          var last = els[els.length - 1];

          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        },

        _cacheFocusable: function () {
          if (!this.$refs.drawer) return;
          this._focusableEls = Array.from(
            this.$refs.drawer.querySelectorAll(
              'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            )
          );
        },

        destroy: function () {
          document.body.style.overflow = '';
        }
      };
    });
  });
  } catch(e) { console.error(e); }
})();

})();
